import React from 'react';

import { IIconProps } from '@icons/interface';

import colors from '@constants/colors';

const UploadedFileIcon = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='26'
			viewBox='0 0 22 26'
			width='22'
		>
			<path
				clipRule='evenodd'
				d='M21.043 7.64455L14.4805 1.08205C14.3019 0.907931 14.0619 0.811109 13.8125 0.812515H2.5625C2.06522 0.812515 1.58831 1.01006 1.23667 1.36169C0.885044 1.71332 0.6875 2.19023 0.6875 2.68751V23.3125C0.6875 23.8098 0.885044 24.2867 1.23667 24.6383C1.58831 24.99 2.06522 25.1875 2.5625 25.1875H19.4375C19.9348 25.1875 20.4117 24.99 20.7633 24.6383C21.115 24.2867 21.3125 23.8098 21.3125 23.3125V8.31251C21.3139 8.06309 21.2171 7.82314 21.043 7.64455ZM13.8125 8.31251V3.15626L18.9688 8.31251H13.8125ZM4.65095 15.5026C5.01045 15.1319 5.60243 15.1228 5.97317 15.4823L9.26345 18.6729L16.4164 11.52C16.7816 11.1548 17.3736 11.1548 17.7388 11.52C18.104 11.8851 18.104 12.4772 17.7388 12.8423L9.97267 20.6085C9.73646 20.8447 9.40531 20.9281 9.10205 20.8587C8.90718 20.8346 8.71824 20.7492 8.56641 20.602L4.67128 16.8249C4.30054 16.4654 4.29144 15.8734 4.65095 15.5026Z'
				fill={props?.color || colors.indigo50}
				fillRule='evenodd'
			/>
		</svg>
	);
};

export default UploadedFileIcon;
